const CalcPercentage = props => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 26.4091C19 26.9614 19.4477 27.4091 20 27.4091C20.5523 27.4091 21 26.9614 21 26.4091H19ZM31 45.5C30.4477 45.5 30 45.9477 30 46.5C30 47.0523 30.4477 47.5 31 47.5V45.5ZM21 5.5H47V3.5H21V5.5ZM47 5.5V45.5H49V5.5H47ZM21 26.4091V5.5H19V26.4091H21ZM47.0005 45.5H31V47.5H47.0005V45.5ZM47 45.5H47.0005V47.5C48.1057 47.5 49 46.6039 49 45.5H47ZM47 5.5H49C49 4.39543 48.1046 3.5 47 3.5V5.5ZM21 3.5C19.8954 3.5 19 4.39543 19 5.5H21V5.5V3.5Z"
      fill="#00619E"
    />
    <rect x="23" y="7.5" width="22" height="11" rx="1" fill="#00619E" />
    <mask id="path-3-inside-1_223_2138" fill="white">
      <rect x="31" y="21.5" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="31"
      y="21.5"
      width="6"
      height="6"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-3-inside-1_223_2138)"
    />
    <mask id="path-4-inside-2_223_2138" fill="white">
      <rect x="31" y="29.5" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="31"
      y="29.5"
      width="6"
      height="6"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-4-inside-2_223_2138)"
    />
    <rect
      x="26.5"
      y="30"
      width="2"
      height="1"
      rx="0.5"
      fill="#00619E"
      stroke="#00619E"
    />
    <rect
      x="27.5016"
      y="32.0016"
      width="2"
      height="1"
      rx="0.5"
      transform="rotate(-89.818 27.5016 32.0016)"
      fill="#00619E"
      stroke="#00619E"
    />
    <mask id="path-7-inside-3_223_2138" fill="white">
      <rect x="31" y="37.5" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="31"
      y="37.5"
      width="6"
      height="6"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-7-inside-3_223_2138)"
    />
    <mask id="path-8-inside-4_223_2138" fill="white">
      <rect x="23" y="21.5" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="23"
      y="21.5"
      width="6"
      height="6"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-8-inside-4_223_2138)"
    />
    <mask id="path-9-inside-5_223_2138" fill="white">
      <rect x="39" y="21.5" width="6" height="6" rx="1" />
    </mask>
    <rect
      x="39"
      y="21.5"
      width="6"
      height="6"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-9-inside-5_223_2138)"
    />
    <mask id="path-10-inside-6_223_2138" fill="white">
      <rect x="39" y="29.5" width="6" height="14" rx="1" />
    </mask>
    <rect
      x="39"
      y="29.5"
      width="6"
      height="14"
      rx="1"
      stroke="#00619E"
      strokeWidth="4"
      mask="url(#path-10-inside-6_223_2138)"
    />
    <circle cx="18" cy="40.5" r="10" stroke="#00AED9" strokeWidth="2" />
    <path
      d="M22 36.5L14 44.5"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="21.5" cy="44" r="1.5" fill="#00AED9" />
    <circle cx="14.5" cy="37" r="1.5" fill="#00AED9" />
  </svg>
);

export default CalcPercentage;
